var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4449_151251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9915 9.16838C16.9915 8.43093 16.9337 7.89279 16.8085 7.33472H8.66895V10.6632H13.4467C13.3504 11.4904 12.8302 12.7361 11.6743 13.5732L11.6581 13.6846L14.2317 15.7472L14.41 15.7657C16.0475 14.201 16.9915 11.899 16.9915 9.16838Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66943 17.9381C11.0101 17.9381 12.9751 17.1408 14.4104 15.7656L11.6748 13.5731C10.9427 14.1013 9.96017 14.47 8.66943 14.47C6.37689 14.47 4.43112 12.9055 3.73751 10.7429L3.63584 10.7519L0.959801 12.8945L0.924805 12.9951C2.35041 15.925 5.27873 17.9381 8.66943 17.9381Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73741 10.7431C3.55439 10.185 3.44847 9.58704 3.44847 8.9692C3.44847 8.35129 3.55439 7.75338 3.72778 7.19531L3.72293 7.07645L1.01336 4.89941L0.924706 4.94304C0.337144 6.15886 0 7.52419 0 8.9692C0 10.4142 0.337144 11.7795 0.924706 12.9953L3.73741 10.7431Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66943 3.46802C10.2973 3.46802 11.3954 4.19551 12.0215 4.80346L14.4682 2.33196C12.9656 0.886946 11.0101 0 8.66943 0C5.27873 0 2.35041 2.01305 0.924805 4.94292L3.72788 7.19519C4.43112 5.03265 6.37689 3.46802 8.66943 3.46802Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4449_151251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.9529317ab7a5080f578fc6e83e6f1237.svg";
export { ForwardRef as ReactComponent };